const baseUrl = `${process.env.REACT_APP_BASE_URL}api/`;
const imageURL = process.env.REACT_APP_CUSTOMER_BASE_URL;
export const customerBaseUrl = imageURL + "api/";
export const vehicleSpecsImageURL = `${imageURL}vehicleImages/`;
export const bookingFilesImageURL = `${imageURL}BookingFiles/`;
export const profileImageURL = `${imageURL}profileImages/`;
export default baseUrl;
// Frontend URL
export const customerWebUrl = "https://moovez.ca/";
